/**-------------------------------
*! Importation des pages          |
*---------------------------------
*/



/**-------------------------------
*! Pages communs                  |
*---------------------------------
*/

export const AJOUT_COURS_NAVIGATION = 'ajout-cours'

/** ------------------------------------------
 *! AUTHENTICATION NAVIGATION                 |
 * -------------------------------------------
 */
 export const ETUDIANT_DASBORD = 'etudiantDasbord'
/** ------------------------------------------
 *! AUTHENTICATION NAVIGATION                 |
 * -------------------------------------------
 */
export const CONNEXION_NAVIGATION = '';
export const INSCRIPTION_NAVIGATION = '/inscription';
export const PASSWORD_OUBLIER_NAVIGATION = 'mot-de-passe-oublie';
export const PASSWORD_RESET_NAVIGATION = 'reinitialiser-mot-de-passe';


/**------------------------------------------
 *! ADMIN NAVIGATION                         |
 * ------------------------------------------
 */
export const ADMIN_NAVIGATION = '/a';
export const CATEGORIE_COURS_NAVIGATION = 'categorie-cours';
export const USERS_ADMIN_NAVIGATION_ETUDIANTS = 'etudiants';
export const USERS_ADMIN_NAVIGATION_PROFS = 'profs';
export const ALL_COURS_NAVIGATION = 'all-cours'
export const DASHBOARD_ADMIN_NAVIGATION = ADMIN_NAVIGATION + '/dashboard/';
export const COURS_ADMIN_NAVIGATION = 'cours/';
export const CATEGORIE_COURS_ADMIN_NAVIGATION = COURS_ADMIN_NAVIGATION + CATEGORIE_COURS_NAVIGATION;
export const AJOUT_COURS__ADMIN = COURS_ADMIN_NAVIGATION + AJOUT_COURS_NAVIGATION
export const USERS_ADMIN_NAVIGATION = 'users/';
export const PROFIL_ADMIN_NAVIGATION = 'profil/';
export const PARAMETRE_ADMIN_NAVIGATION = 'parametre/';
export const  MODIFIER_PROFIL =  'modification-profil';
export const MODIFIER_PROFIL_ADMIN_NAVIGATION = PROFIL_ADMIN_NAVIGATION +  MODIFIER_PROFIL


/**------------------------------------------
 *! PROF NAVIGATION                         |
 * ------------------------------------------
 */
export const PROF_NAVIGATION = 'p';
export const DASHBOARD_PROF_NAVIGATION = PROF_NAVIGATION + '/dashboard/'
export const COURS_PROF_NAVIGATION = 'cours/'
export const ETUDIANTS_PROF_NAVIGATION = 'etudiants/'
export const PROFIL_PROF_NAVIGATION = 'profil/'
export const MODIFIER_PROFIL_PROF_NAVIGATION = PROFIL_PROF_NAVIGATION +  MODIFIER_PROFIL
export const PARAMETRE_PROF_NAVIGATION = 'parametre/'


/**------------------------------------------
 *! ETUDIANT NAVIGATION                         |
 * ------------------------------------------
 */
export const ETUDIANT_NAVIGATION = 'e';
export const DASHBOARD_ETUDIANT_NAVIGATION = ETUDIANT_NAVIGATION + '/dashboard/'
export const COURS_ETUDIANT_NAVIGATION = 'cours/'
export const PROFIL_ETUDIANT_NAVIGATION = 'profil/'
export const MODIFIER_PROFIL_ETUDIANT_NAVIGATION = PROFIL_ETUDIANT_NAVIGATION +  MODIFIER_PROFIL
 export const PARAMETRE_ETUDIANT_NAVIGATION = 'parametre/'
